<template>
    <div>
        <v-card class="fill-height" elevation="0">
            <v-card color="#8FABB3" elevation="0" height="150px" class="d-flex align-content-end">
                <v-card-title class="white--text text-h5">
                    <v-icon color="white" large>mdi-cog-outline</v-icon>
                    &nbsp;Settings
                </v-card-title>
            </v-card>
            <v-card-text>
                Various configuration setups can be modified here. Changes made on this page impact student experience on SFS portal.
                <br /><br />
                <i>Turning on <b>Edit Mode</b> allows instant change on the settings.</i> Please turn it off when not updating configuration settings. 
            </v-card-text>
            <v-card-text>
                <ConfigManager />
            </v-card-text>
        </v-card>
    </div>
</template>
<script>
import ConfigManager from "../../../components/Admin/Config/Manager.vue"
export default {
    components: {
        ConfigManager
    }
}
</script>